interface Props {
	iconColor?: string;
	width?: string;
	height?: string;
	strokeWidth?: string;
}
const SingleArrowPrev = ({ iconColor = '#868E96', width = '24', height = '24', strokeWidth = '1.5' }: Props) => (
	<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M15 19L8.84853 12.8485C8.3799 12.3799 8.3799 11.6201 8.84853 11.1515L15 5" stroke={iconColor} strokeWidth={strokeWidth} strokeLinecap="round" />
	</svg>
);

export default SingleArrowPrev;
